export default "__VITE_ASSET__D1E0AZ_u__"